import { tv } from '~/utils/tv'
import { Tag, type TagProps } from '../tag'

const popoverTag = tv({
  base: ['pt-twopulse pr-twopulse pl-twopulse'],
})

export type PopoverTagProps = Omit<TagProps, 'variants'>

export function PopoverTag({ children, ...props }: PopoverTagProps) {
  return (
    <div className={popoverTag()}>
      <Tag.Root variants="principal" {...props}>
        <Tag.Label>{children}</Tag.Label>
      </Tag.Root>
    </div>
  )
}

PopoverTag.displayName = 'PopoverTag'
